import { render, staticRenderFns } from "./admin-processors.vue?vue&type=template&id=25571bae&scoped=true&"
import script from "./admin-processors.vue?vue&type=script&lang=js&"
export * from "./admin-processors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25571bae",
  null
  
)

export default component.exports